import React, { useEffect, useCallback, useState  } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getDetailFacture,
  getFactureById,
} from "../../Redux/factureReduce";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
function DetailsFacture() {
  const dispatch = useDispatch();
  const location = useParams();
  var idFacture = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [facture, setFacture] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailFacture */
  const detailFacture = useCallback(async (idFacture) => {
    var det = await dispatch(getDetailFacture(idFacture));
    var dataD = await det.payload;
    setData(dataD)
    setLoader(false)
    var dataFacture = await dispatch(getFactureById(idFacture));
    var factureD = await dataFacture.payload;
    setFacture(factureD);
  }, [dispatch, idFacture]);




  useEffect(() => {
    detailFacture(idFacture)
  }, [idFacture, id]);



  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("facture_details")}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("No_facture")}</th>
                              <th>Code {t("Wholesaler")}</th>
                              <th>{t("Wholesaler")}</th>
                              <th>{t("Date")}</th>
                              <th>{t("Montant_HT_TND")}</th>
                              <th>{t("Montant_TTC_TND")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{facture.NumFacture}</td>
                              <td>{facture.CodeClient}</td>
                              <td>{facture.Raison_sociale}</td>
                              <td>{facture.DateFacture}</td>
                              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(parseFloat(facture.MontantHT_TND))}</td>
                              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(parseFloat(facture.MontantTTC_TND))}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("No_commande")}</th>
                              <th>{t("No_livraison")}</th>
                              <th>{t("code_article")}</th>
                              <th>{t("designation")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((e) => {
                              return (
                                <tr key={"ligne-" + e.id}>
                                  <td>{e.NumCommande}</td>
                                  <td>{e.NumLivraison}</td>
                                  <td>{e.CodeArticle}</td>
                                  <td>{e.DesignationArticle}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsFacture;
